import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Spin } from 'antd';
import SearchForm from './components/SearchForm'
import SearchResult from './components/SearchResult'
@inject('connectionMonitorStore')
@observer
class ConnectionMonitor extends Component {
  state = {
  }
  componentDidMount() {
  }
  render() {
    const { connectionMonitorStore } = this.props
    const { isFetching } = connectionMonitorStore
    return (
      <Spin spinning={isFetching}>
        <div className="container">
          <SearchForm />
          <SearchResult />
        </div>
      </Spin>
    );
  }
}
export default ConnectionMonitor;
